import { useState, type ReactNode } from 'react';
import { CollapsibleCard } from './CollapsibleCard';
import './card.css';

const KEY = 'kontor:factbox';

function readShown(): boolean {
  try {
    return window.localStorage.getItem(KEY) !== '0';
  } catch {
    return true;
  }
}

/**
 * Rahmen einer großen Karte mit seitlicher Infobox nach dem Vorbild der FactBox in Business Central: links die Karte mit ihren Bereichen, rechts die
 * wichtigsten Angaben und Zahlen auf einen Blick. Die Infobox lässt sich aus- und einblenden, Wirkia merkt sich das pro Browser. Unter 1100 Pixel
 * steht sie unter der Karte.
 */
export function CardLayout({ children, factbox, className = '' }: { children: ReactNode; factbox: ReactNode; className?: string }) {
  const [shown, setShown] = useState(readShown);
  const toggle = () => {
    const next = !shown;
    setShown(next);
    try {
      window.localStorage.setItem(KEY, next ? '1' : '0');
    } catch {
      // nur für diese Sitzung
    }
  };
  return (
    <div className={`cardlayout${shown ? '' : ' is-single'} ${className}`.trim()}>
      <div className="cardlayout__bar">
        <button type="button" className="btn btn--secondary btn--sm" aria-pressed={shown} onClick={toggle}>{shown ? 'Infobox ausblenden' : 'Infobox einblenden'}</button>
      </div>
      <div className="cardlayout__main">{children}</div>
      {shown && <aside className="factbox" aria-label="Infobox">{factbox}</aside>}
    </div>
  );
}

/** Ein Bereich der Infobox mit Titel, aufklappbar, anfangs offen */
export function FactBoxPart({ title, storageKey, children }: { title: string; storageKey: string; children: ReactNode }) {
  return (
    <CollapsibleCard title={title} className="factbox__part" storageKey={`fb-${storageKey}`} defaultOpen>
      {children}
    </CollapsibleCard>
  );
}

/** Eine Zeile „Beschriftung: Wert“ in der Infobox. Ohne Wert steht ein Strich. */
export function FactRow({ label, children }: { label: string; children?: ReactNode }) {
  const empty = children === null || children === undefined || children === '' || children === false;
  return (
    <div className="factrow">
      <span className="factrow__label">{label}</span>
      <span className="factrow__value">{empty ? <span className="muted">–</span> : children}</span>
    </div>
  );
}
